import { render } from "./BoxEdit.vue?vue&type=template&id=247c71fa&ts=true"
import script from "./BoxEdit.vue?vue&type=script&lang=ts"
export * from "./BoxEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__